import { useCallback, useEffect, useState } from 'react';
import api from '../services/api';

/**
 * Fuente única de clases admin (lista + calendario comparten el mismo fetch).
 */
export function useLiveClassesAdmin(scopeGymId = null) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchItems = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const params = {};
      if (scopeGymId) params.gym_id = scopeGymId;
      const resp = await api.get('/live-classes/admin', { params });
      const rows = resp.data?.data || [];
      rows.sort((a, b) => new Date(a.start_time) - new Date(b.start_time));
      setItems(rows);
      return rows;
    } catch {
      setError('No se pudo cargar la lista de clases.');
      return [];
    } finally {
      setLoading(false);
    }
  }, [scopeGymId]);

  useEffect(() => {
    fetchItems();
  }, [fetchItems]);

  return { items, loading, error, fetchItems, setItems };
}
